import React, { useEffect } from "react";
import { renderRoutes } from "react-router-config";
import { useLocation } from "react-router-dom";
import OrderHeader from "./fragments/order-header";
import { matchRoutes } from 'react-router-config'
import { useState } from "react";
import { useRef } from "react";

export default ({ route }) =>{
    const [showHeader, setShowHeader] = useState(false);
    const [slideNext, setSlideNext] = useState(false);
    const location = useLocation();
    const initRef = useRef(true);

    useEffect(() =>{
        const branches = matchRoutes(route.routes, location.pathname);
        setShowHeader(branches?.[0]?.route?.meta?.showHeader);
        if(initRef.current){
            setSlideNext(branches?.[0]?.route?.meta?.slideNext);
        }
    }, [route, location]);


    return <div>
        {
            showHeader && <OrderHeader slideNext={slideNext} />
        }

        {renderRoutes(route.routes)}
    </div>
}